// function searchVendors () {
//   const filter = document.getElementById('search-vendors-input').value
//   const ul = document.getElementById('vendors-home-list')
//   const li = ul.getElementsByTagName('li')
//   for (let i = 0; i < li.length; i++) {
//     const elemText = li[i].getElementsByTagName('a')[0].text
//     li[i].style.display = !filter || elemText.toUpperCase().includes(filter.toUpperCase()) ? '' : 'none'
//   }
// }

// const searchVendorInput = $('#search-vendors-input')

// searchVendorInput.focusin(function () {
//   $('#vendors-home-list').fadeIn('fast')
// })
// searchVendorInput.focusout(function () {
//   $('#vendors-home-list').fadeOut(1000)
// })
// searchVendorInput.on('keyup', function () { searchVendors() })

// var swiper = new Swiper(".homeMainSlider", {});
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.main-slide-title');
  const spans = Array.from(container.querySelectorAll('span'));
  let currentIndex = 0;

  if (spans.length === 0) return;

  // Initially show the first span
  spans[0].classList.add('active');

  setInterval(() => {
    const current = spans[currentIndex];
    const nextIndex = (currentIndex + 1) % spans.length;
    const next = spans[nextIndex];

    // Mark current to exit upward
    current.classList.remove('active');
    current.classList.add('exiting');

    // Next span enters from below
    next.classList.add('active');

    // Clean up exiting class after animation
    setTimeout(() => {
      current.classList.remove('exiting');
    }, 600); // Match transition duration

    currentIndex = nextIndex;
  }, 2500); // Change every 2.5s (adjust as needed)
});



// Bunny CDN Video Autoplay on Viewport
// function isFullyInViewport(element) {
//     const rect = element.getBoundingClientRect();
//     const windowHeight = window.innerHeight || document.documentElement.clientHeight;
//     const windowWidth = window.innerWidth || document.documentElement.clientWidth;
    
//     // Check if at least 30% of the element is visible in the viewport
//     const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
//     const visibleWidth = Math.min(rect.right, windowWidth) - Math.max(rect.left, 0);
//     const visibleArea = visibleHeight * visibleWidth;
//     const elementArea = element.offsetWidth * element.offsetHeight;
    
//     return (visibleArea / elementArea) >= 0.3;
// }

// function handleVideoAutoplay() {
//     const video = document.getElementById('bunnyVideo');
//     if (!video) return;

//     const isVisible = isFullyInViewport(video);
//     const currentSrc = video.getAttribute('src');
//     const dataSrc = video.getAttribute('data-src');

//     if (isVisible) {
//         // Only set the src when video is fully in view and not already loaded
//         if (!currentSrc && dataSrc) {
//             video.setAttribute('src', dataSrc + '&autoplay=true');
//         } else if (currentSrc && !currentSrc.includes('autoplay=true')) {
//             video.setAttribute('src', currentSrc + '&autoplay=true');
//         }
//     } else if (currentSrc && currentSrc.includes('autoplay=true')) {
//         // Only reset if currently playing
//         video.setAttribute('src', currentSrc.replace('autoplay=true', 'autoplay=false'));
//     }
// }

// // Run on load, scroll, and resize
// if (document.getElementById('bunnyVideo')) {
//     // Don't run initial check - wait for scroll
    
//     // Throttle the scroll and resize events for better performance
//     let isThrottled = false;
//     const throttledHandler = () => {
//         if (!isThrottled) {
//             handleVideoAutoplay();
//             isThrottled = true;
//             setTimeout(() => {
//                 isThrottled = false;
//             }, 200);
//         }
//     };

//     // Use intersection observer for better performance
//     const observer = new IntersectionObserver((entries) => {
//         entries.forEach(entry => {
//             if (entry.isIntersecting) {
//                 handleVideoAutoplay();
//             } else {
//                 const video = entry.target;
//                 const currentSrc = video.getAttribute('src');
//                 if (currentSrc && currentSrc.includes('autoplay=true')) {
//                     video.setAttribute('src', currentSrc.replace('autoplay=true', 'autoplay=false'));
//                 }
//             }
//         });
//     }, {
//         threshold: 0.8 // Trigger when 80% of the video is visible
//     });

//     const video = document.getElementById('bunnyVideo');
//     if (video) {
//         observer.observe(video);
//         window.addEventListener('scroll', throttledHandler);
//         window.addEventListener('resize', throttledHandler);
//     }
// }

// overlay effect on home page video under main slider
function triggerExpandAnimation() {
  const overlay = document.querySelector('.video-expand-overlay');
  overlay.style.animation = 'none';
  // Trigger reflow
  void overlay.offsetWidth;
  overlay.style.animation = 'expandOverlay 1.5s ease-out forwards';
}



